import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=2cb031da&scoped=true&lang=css"

import exportComponent from "/opt/data/jenkins/workspace/auto-build-release-node-server-new-2024/TMP/PROD/ashe/ashe-activity/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cb031da"]])

export default __exports__